import DOMPurify from "dompurify";

// Sanitisation HTML (texte riche du CMS) via DOMPurify : bloque script, handlers on*,
// schémas dangereux (javascript:, data:), SVG/MathML, xlink:href, etc.
export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ALLOWED_ATTR: ["href", "title", "target", "rel", "style", "color", "align"],
  });
}

// Autorise uniquement les schémas sûrs ; neutralise javascript:/data:/vbscript: et
// les caractères de contrôle insérés pour contourner les filtres.
export function safeUrl(u = "") {
  const raw = String(u);
  const v = raw.replace(/[\u0000-\u0020]/g, "").toLowerCase();
  if (v.startsWith("/") || v.startsWith("#") || v.startsWith("mailto:") || v.startsWith("tel:") || v.startsWith("http://") || v.startsWith("https://")) {
    return raw;
  }
  return "#";
}
